module.exports = __webpack_public_path__ + "static/smille-b3a358d207b4177aded17e928a55dd68.svg";